<!-- این فرم از سامانه مالی پرش حذف و به مدیریت پرش منتقل شد -->
<!-- صحت عمل فرم در تاریخ 1402/04/06 کنترل و تایید شد -->
<template>
  <div class="row">
    <div class="col-12 p-0">
      <div class="row p-0 d-flex justify-content-between align-items-center">
        <div class="col-4 p-0 pb-2">
          <div class="input-group p-0">
            <input id="userInfotextDocInfoSearch" placeholder="جستجو پیشرفته در لیست کاربران (Enter)" type="text"
              class="form-control form-control-sm rounded-0" v-on:focus="$event.target.select()"
              v-on:keyup.enter="searchData($event.target.value)" />
            <div class="input-group-prepend rounded-0">
              <span class="
                  input-group-text input-group-box-size
                  bg-secondary
                  rounded-left
                  white-text
                ">
                <a v-on:click="searchData('Search')">
                  <i class="fas fa-search"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
        <div class="col-4 p-0 pb-2 d-flex justify-content-end align-items-center">
          <a class="
              btn btn-secondary btn-sm btn-floating
              p-0
              m-0
              d-flex
              justify-content-around
              align-items-center" 
            style="width: 80px; height: 30px" 
            title="ایجاد کاربر جدید" 
            data-toggle="modal"
            data-target="#ModalAddNewUserList"
            v-on:click="addNewUser"
          >
            کاربر جدید
            <i class="fas fa-user-plus fa-1x-half text-white"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-sm text-center table-font-size">
        <!-- سربرگ جدول -->
        <thead class="text-light bg-secondary">
          <td style="max-width: 50px">ردیف</td>
          <td>کد کاربر</td>
          <td>نام کاربر</td>
          <td>تاریخ ثبت</td>
          <td>کد ملی</td>
          <td>تلفن همراه</td>
          <td>سازمان</td>
          <td>وضعیت فعالیت</td>
          <td>مدیریت</td>
        </thead>
        <!-- بدنه جدول -->
        <tbody>
          <template v-for="(row, index) in getListTbUsersInfo">
            <tr :key="row.NUserCode" :class="{ selRow: SelectRowID == row.NUserCode }" v-on:click="SaveRowSelect(row)"
              v-bind:id="row.NUserCode" style="cursor: pointer">
              <!-- ردیف -->
              <td style="
                  max-width: 50px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ index + 1 }}
              </td>
              <!-- کد کاربر -->
              <td style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ row.NUserCode }}
              </td>
              <!-- نام کاربر -->
              <td style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ row.SUserName }}
              </td>
              <!-- تاریخ ثبت -->
              <td style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ row.SDate }}
              </td>
              <!-- کد ملی -->
              <td style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ row.NPerNationalId }}
              </td>
              <!-- تلفن همراه -->
              <td style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                ">
                {{ row.SMobileNo }}
              </td>
              <!-- سازمان -->
              <td style="
                  text-align: right !important;
                  padding-right: 5px !important;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  max-width: 250px;
                ">
                {{ row.SOrgName }}
              </td>
              <!-- وضعیت فعالیت -->
              <td v-bind:class="row.NState != 1 ? 'text-danger' : 'text-info'"
                v-bind:style="row.NState == 3 ? 'font-weight: bold !important;' : ''">
                {{ row.StateActive }}
              </td>
              <!-- مدیریت -->
              <td style="
                  max-width: 140px;
                  padding-left: 5px !important;
                  padding-right: 5px !important;
                ">
                <!-- منوی مشاهده سوابق فعالیت کاربر -->
                <a href="#" title="مشاهده سوابق فعالیت کاربر" v-on:click="CallShowActivityList(row)">
                  <!-- <i class="far fa-eye fa-lg m-1 text-primary"></i> -->
                  <i class="fas fa-calendar-check fa-lg m-1 text-secondary"></i>
                </a>
                <!-- منوی ویرایش پروفایل کاربری -->
                <a href="#" title="ویرایش" v-on:click="CallUserProfileEdit(row.NUserCode)" data-toggle="modal"
                  data-target="#ModalUserProfileEditUserList">
                  <!-- <i class="far fa-eye fa-lg m-1 text-primary"></i> -->
                  <i class="fas fa-user-edit fa-lg m-1 text-success"></i>
                </a>
                <!-- منوی تنظیم سطح دسترسی -->
                <a href="#" title="سطح دسترسی" v-on:click="CallManageAccessUser(row.NUserCode)" data-toggle="modal"
                  data-target="#ModalManageAccessUser">
                  <i class="fas fa-user-shield fa-lg m-1 text-primary"></i>
                </a>
                <!-- منوی تغییر وضعیت فعالیت -->
                <a v-if="row.NState != 1" href="#" title="فعالسازی کاربر" v-on:click="CallChaneNStateUser(true, row.NUserCode, row.SUserName)">
                  <i class="fas fa-user-check fa-lg m-1 cyan-text"></i>
                </a>
                <!-- منوی تغییر وضعیت فعالیت -->
                <a v-else href="#" title="غیرفعالسازی کاربر"
                  v-on:click="CallChaneNStateUser(false, row.NUserCode, row.SUserName)">
                  <i class="fas fa-user-times fa-lg m-1 amber-text"></i>
                </a>
                <!-- منوی حذف کاربر -->
                <a href="#" title="حذف کاربر" v-on:click="CallDeleteUser(row.NUserCode, row.SUserName)">
                  <i class="fas fa-user-minus fa-lg m-1 pink-text"></i>
                </a>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <!-- مودال ثبت کاربر جدید -->
    <add-new-user 
      v-on:AddNewUser="HideModalAddNewUser"
      v-bind:ActiveComponent="ActiveComponentRandomValue"
    ></add-new-user>
    <!-- پایان مودال ثبت کاربر جدید -->

    <!-- مودال ویرایش حساب کاربری -->
    <user-profile-edit v-bind:UserData="userDataForEditProfile"
      v-on:EditUser="HideModalUserProfileEdit"></user-profile-edit>
    <!-- پایان مودال ویرایش حساب کاربری -->

    <!-- مودال مدیریت سطح دسترسی کاربر -->
    <ManageAccessUser v-bind:UserData="SelectRowData" v-bind:ResourceAccessUser="ResourceAccessUser"></ManageAccessUser>
    <!-- پایان مودال مدیریت سطح دسترسی کاربر -->

  </div>
</template>

<script>
import UserProfileEdit from "./Components/UserProfileEdit.vue";
import AddNewUser from "./Components/AddNewUser.vue";
import ManageAccessUser from "./Components/ManageAccessUser.vue"

export default {
  props: {
    // پراپرتی دریافت تب اکتیو
    tabID: { type: Number },
  },
  created() {},
  components: {
    "user-profile-edit": UserProfileEdit,
    "add-new-user": AddNewUser,
    ManageAccessUser
  },
  data() {
    return {
      // آیدی سطر انتخاب شده
      SelectRowID: 1,
      // اطلاعات سطر انتخاب شده
      SelectRowData: {},
      // لیست دسترسی های کاربر
      ResourceAccessUser: [],
      // لیست محلی کاربران
      ListTbUsersInfo: [],
      // موارد جستجو شده قبلی
      NUserCodeSearch: [],
      // فیلد نگهداری نام آخرین فیلد مرتب سازی شده
      lastSortFieldName: "",
      // آدرس تصویر لطفا صبر کنید
      waitImage: this.$store.getters.getImageUrl + "wait.gif",
      // کنترل نمایش ویرایش اطلاعات پروفایل
      userDataForEditProfile: "",
      // مقدار تصادفی تحریک کنند کامپاننت درج کاربر جدید
      ActiveComponentRandomValue: 0,
    };
  },
  computed: {
    // دریافت اطلاعات لیست کاربران از مخزن
    getListTbUsersInfo() {
      this.ListTbUsersInfo = this.$store.getters.getListTbUsersInfo;
      let NUserCode = this.$store.getters.getUserData.NUserCode;
      return this.ListTbUsersInfo.filter(function (item) {
        return item.NUserCode != NUserCode
        // return item
      });
    },
  },
  methods: {
    addNewUser(){
      this.ActiveComponentRandomValue = Math.random() * 10;
      console.log(this.ActiveComponentRandomValue);
    },
    // رویداد مدیریت سطح دسترسی کاربر
    async CallManageAccessUser(NUserCode) {
      // دریافت لیست دسترسی های کاربر از سرور
      let token = await this.$store.getters.getUserData.token;
      this.ResourceAccessUser = await this.$store.dispatch(
        "getResourceAccessUserFromServer",
        { NUserCode, token }
      );
    },

    // رویداد ویرایش حساب کاربری
    async CallUserProfileEdit(NUserCode) {
      let token = await this.$store.getters.getUserData.token;
      var userData = await this.$store.dispatch(
        "getUserProfileDataFromServer",
        { NUserCode, token }
      );
      console.log(userData);
      // فراخوانی کامپاننت ویرایش اطلاعات
      this.userDataForEditProfile = userData;
      // }
    },

    // فراخوانی سوابق فعالیت کاربر
    async CallShowActivityList(RowUserData) {
      // ثبت کد ملی کاربر جاری جهت فیلتر سوابق فعالیت
      this.$store.commit("setOnlyShowActivityListForUserID", RowUserData.NPerNationalId);
      // فراخوانی تابع نمایش فرم سوابق فعالیت
      // this.addNewTab('ActivityList','سوابق فعالیت کاربر (' + RowUserData.SUserName + ')');
      // ایجاد اطلاعات تب جدید
      let newNDocNum = await this.$store.dispatch("createNewNDouNum");
      var tabData = {
        tabID: 0,
        tabContent: 'ActivityList',
        tabContentTitle: 'سوابق فعالیت کاربر (' + RowUserData.SUserName + ')',
        NId: 0,
        NDocNu: newNDocNum,
        CheckChangeData: false,
        LocalData: false,
        TabAccDocData: {},
      };
      // ایجاد تب جدید
      this.$store.commit("addTabList", tabData);
      // ارسال شماره تب به رویداد تغییر تب فعال
      BusEvent.$emit("ChangeTabActive", tabData.tabID);
    },

    // رویداد حذف کاربر
    async CallDeleteUser(NUserCode, SUserName) {
      swal({
        title: "تقاضای حذف کاربر",
        text:
          "آیا کاربر ( " + NUserCode + " - " + SUserName + " ) حذف شود ؟",
        icon: "warning", // success, warning, error, info
        buttons: {
          cancel: "انصراف",
          ok: "بله این کاربر حذف شود",
        },
      }).then(async (value) => {
        if (value) {
          // نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            notText: "حذف کاربر از سرور",
          });

          let token = await this.$store.getters.getUserData.token;
          var userData = await this.$store.dispatch("CallDeleteUserFromServer", { NUserCode, token });

          // لغو نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            stop: true,
          });
        }
      });
    },

    // تغییر وضعیت فعالیت کاربر
    async CallChaneNStateUser(ActiveStatus, NUserCode, SUserName) {
      swal({
        title: "تقاضای " + (ActiveStatus == true ? "فعالسازی" : "غیرفعالسازی") + " کاربر",
        text:
          "آیا کاربر ( " + NUserCode + " - " + SUserName + " ) " + (ActiveStatus == true ? "فعال" : "غیرفعال") + " شود ؟",
        icon: "warning", // success, warning, error, info
        buttons: {
          cancel: "انصراف",
          ok: "بله این کاربر " + (ActiveStatus == true ? "فعال" : "غیرفعال") + " شود",
        },
      }).then(async (value) => {
        if (value) {
          // نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            notText: (ActiveStatus == true ? "فعالسازی" : "غیرفعالسازی") + " کاربر از سرور",
          });

          let token = await this.$store.getters.getUserData.token;
          var userData = await this.$store.dispatch("ChangeNStateUserFromServer", { NUserCode, ActiveStatus, token });

          // لغو نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            stop: true,
          });
        }
      });
    },

    // رویداد بسته شدن مودال ویرایش حساب کاربری
    async HideModalUserProfileEdit(value) {
      this.$store.commit("setChangeUserProfileDataInList", { userData: value });
    },

    // بسته شدن مودال درج کاربر جدید
    async HideModalAddNewUser(value) {
      this.$store.commit("AddNewUserToLocalList", { userData: value });
    },

    // نگهداری اطلاعات سطر انتخاب شده
    SaveRowSelect(RowData) {
      this.SelectRowData = RowData;
      this.SelectRowID = RowData.NUserCode;
    },

    // جستجو در لیست کاربران
    searchData(searchValue) {
      if (searchValue === "Search") {
        searchValue =
          $("#userInfotextDocInfoSearch").val() != ""
            ? $("#userInfotextDocInfoSearch").val()
            : "";
      }
      if (searchValue != "") {
        let index = this.ListTbUsersInfo.findIndex(
          (item) =>
            (item.NUserCode.toString().startsWith(searchValue) ||
              item.SUserName.toString().includes(searchValue) ||
              item.NPerNationalId.toString().startsWith(searchValue) ||
              item.SMobileNo.toString().startsWith(searchValue) ||
              item.SOrgName.toString().includes(searchValue)) &&
            this.NUserCodeSearch.indexOf(item.NUserCode) == -1
        );
        if (index != -1) {
          let NUserCode = this.ListTbUsersInfo[index].NUserCode;
          $("#" + NUserCode).scrollintoview({
            duration: 500,
            //complete: this.$store.dispatch("notify", { notText: "تست نمایش پیام !!", timeOut: 2500, });
          });
          this.SelectRowID = NUserCode;
          this.SelectRowData = this.ListTbUsersInfo[index];

          this.NUserCodeSearch.push(NUserCode);
        } else {
          // this.$store.dispatch("notify", {
          //     notText: "برای مقدار ( " + searchValue + " ) موردی پیدا نشد !",
          //     timeOut: 2500,
          // });
          this.NUserCodeSearch = [];
          // فراخوانی مجدد تابع باعث ایجاد لوپ می شود
          // this.searchData(searchValue);
        }
      } else {
        this.$store.dispatch("notify", {
          notText: "مقداری برای جستجو درج نشده است !",
          timeOut: 2500,
        });
        this.NUserCodeSearch = [];
      }
    },

    // مرتب سازی لیست بر اساس فیلد انتخابی
    sortDocRow: function (sortFieldName, sortFieldType) {
      // منبع مطلب
      // https://www.codegrepper.com/code-examples/javascript/frameworks/vue/Sort+numbers+in+javascript
      let docrow = this.ListTbDocInfo;
      // بررسی وضعیت مرتب سازی صعودی یا نزولی
      if (sortFieldType === "") {
        if (this.lastSortFieldName === sortFieldName) {
          // فیلد تکراری است لذا مرتب سازی از بزرگ به کوچک
          sortFieldType = "desc";
          // تخلیه نام آخرین فیلد مرتب سازی شده
          this.lastSortFieldName = "";
        } else {
          // فیلد جدید است لذا مرتب سازی از کوچک به بزرگ
          sortFieldType = "asc";
          // نگهداری نام آخرین فیلد مرتب سازی شده
          this.lastSortFieldName = sortFieldName;
        }
      }

      // Set slice() to avoid to generate an infinite loop!
      // تکه تکه کردن() برای جلوگیری از تولید یک حلقه بی نهایت!
      if (docrow.length > 0) {
        if (sortFieldName === "NId") {
          // شناسه سند
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.ListTbDocInfo = docrow.sort((a, b) => a.NId - b.NId);
          else this.ListTbDocInfo = docrow.sort((a, b) => b.NId - a.NId);
        }
        if (sortFieldName === "NYear") {
          // سال
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.ListTbDocInfo = docrow.sort((a, b) => a.NYear - b.NYear);
          else this.ListTbDocInfo = docrow.sort((a, b) => b.NYear - a.NYear);
        } else if (sortFieldName === "NDocNu") {
          // شماره سند
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.ListTbDocInfo = docrow.sort((a, b) => a.NDocNu - b.NDocNu);
          else this.ListTbDocInfo = docrow.sort((a, b) => b.NDocNu - a.NDocNu);
        } else if (sortFieldName === "SDocDate") {
          // تاریخ
          // مرتب سازی فیلد متنی
          this.ListTbDocInfo = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SDocDate;
              f2 = b.SDocDate;
            } else {
              f1 = b.SDocDate;
              f2 = a.SDocDate;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "SDocType") {
          // نوع سند
          // مرتب سازی فیلد متنی
          this.ListTbDocInfo = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SDocType;
              f2 = b.SDocType;
            } else {
              f1 = b.SDocType;
              f2 = a.SDocType;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "SDocDesc") {
          // شرح سند
          // مرتب سازی فیلد متنی
          this.ListTbDocInfo = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SDocDesc;
              f2 = b.SDocDesc;
            } else {
              f1 = b.SDocDesc;
              f2 = a.SDocDesc;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "NDebit") {
          // بدهکار
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.ListTbDocInfo = docrow.sort((a, b) => a.NDebit - b.NDebit);
          else this.ListTbDocInfo = docrow.sort((a, b) => b.NDebit - a.NDebit);
        } else if (sortFieldName === "NCredit") {
          // بستانکار
          // مرتب سازی فیلد عددی
          if (sortFieldType === "asc")
            this.ListTbDocInfo = docrow.sort((a, b) => a.NCredit - b.NCredit);
          else
            this.ListTbDocInfo = docrow.sort((a, b) => b.NCredit - a.NCredit);
        } else if (sortFieldName === "SStatus") {
          // وضعیت سند
          // مرتب سازی فیلد متنی
          this.ListTbDocInfo = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SStatus;
              f2 = b.SStatus;
            } else {
              f1 = b.SStatus;
              f2 = a.SStatus;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        } else if (sortFieldName === "SOrgCode") {
          // سازمان
          // مرتب سازی فیلد متنی
          this.ListTbDocInfo = docrow.sort((a, b) => {
            let f1 = "",
              f2 = "";
            if (sortFieldType === "asc") {
              f1 = a.SOrgCode;
              f2 = b.SOrgCode;
            } else {
              f1 = b.SOrgCode;
              f2 = a.SOrgCode;
            }

            if (f1 < f2) {
              return -1;
            }
            if (f1 > f2) {
              return 1;
            }
            return 0;
          });
        }
      } else {
        return [];
      }
    },
  },
};
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}

.rowBoxShadow {
  box-shadow: rgb(126 72 156 / 15%) 0px -2px 3px;
}

.tdGradient {
  background: linear-gradient(rgba(233, 233, 233, 0.4), rgba(255, 255, 255, 1));
}

.tdGradient2 {
  background: linear-gradient(rgba(233, 233, 233, 0.4),
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 1));
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListUserInfo/ListUserInfo.vue